import styled from '@emotion/styled'
import { Box, Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import Footer from './Footer'

const SignUpBox = styled(Box)({
    background: '#252525',
    height: 'auto',
})

const SignUp = () => {

  return (
    <SignUpBox>
        <Box style={{height: '40rem', width: '90vw',  margin: 'auto', position: 'relative', top: '10rem', background: '#252525'}}>
            <h2 style={{lineHeight: '3rem', color: "white"}}>Login</h2>
            <h5 style={{color: 'white'}}>Please eneter your email and password</h5>
            <form action="" style={{display: 'flex', flexDirection: 'column', width: '21rem', margin: 'auto', gap: '1rem'}}>
                <input type="text" style={{width: '20rem', margin: 'auto', height: '2.5rem', borderRadius: '0.5rem', border: '1px solid gray', background: '#252525',}} required placeholder='E-mail' />
                <input type="text" style={{width: '20rem', margin: 'auto', height: '2.5rem', borderRadius: '0.5rem', border: '1px solid gray', background: '#252525',}} required placeholder='Password' />
                <Button style={{background: 'red', color: 'white', fontWeight: 'bold'}}>LOGIN</Button>
            </form>
            <h5 style={{color: 'white'}}>new customer? 
                <Link to='/create'>
                    <span style={{color: 'white'}}><i>Create an account</i></span>
                </Link>
            </h5>
        </Box>
        <Box style={{zIndex: 3, paddingTop: '10rem', marginTop: '5rem'}}>
        <Footer />
        </Box>
    </SignUpBox>
  )
}

export default SignUp